export const APP_SCROLL_CONTAINER_SELECTOR = '[data-slot="sidebar-inset"]'
